import { Injectable, inject } from "@angular/core";
import { PlataformaService } from "@pucomex-ng-infra/pucx-plataforma-client";
import { get, intersection } from "lodash";

/**
 * Serviço que facilita a verificação da visão, perfis e transações do usuário logado
 */
@Injectable({
  providedIn: "root",
})
export class UsuarioService {
  private readonly plataformaService = inject(PlataformaService);

  get usuarioLogado() {
    return this.plataformaService.getUsuario();
  }

  get isAcessoPublico() {
    return this.usuarioLogado.tipo == "ACESSO_PUBLICO";
  }

  get possuiVisaoRFB(): boolean {
    return this.possuiVisao("RFB");
  }

  get possuiVisaoPRIV(): boolean {
    return this.possuiVisao("PRIV");
  }

  public possuiVisao(...visao: string[]): boolean {
    return visao.includes(get(this.usuarioLogado, "visao", ""));
  }

  public possuiPerfil(...perfil: string[]): boolean {
    const perfisUsuario = get(this.usuarioLogado, "perfis", []).map(
      (p) => p.id,
    );
    const resultado = intersection(perfisUsuario, perfil);
    return resultado.length > 0;
  }

  public possuiTransacao(perfil: string, ...transacao: string[]): boolean {
    return !!get(this.usuarioLogado, "perfis", []).find(
      (p) =>
        p.id === perfil &&
        intersection(p.transacoes || [], transacao).length > 0,
    );
  }

  public possuiTodasTransacoes(transacoes: string | string[]): boolean {
    transacoes = !Array.isArray(transacoes) ? [transacoes] : transacoes;
    return !!get(this.usuarioLogado, "perfis", []).find(
      (p) =>
        intersection(p.transacoes || [], transacoes).length ===
        transacoes.length,
    );
  }

  public possuiPerfis(perfis: string | string[]): boolean {
    perfis = !Array.isArray(perfis) ? [perfis] : perfis;
    perfis = perfis.join(",");
    return this.possuiPerfil(perfis);
  }

  public obterInfoRfb() {
    if (this.possuiVisaoRFB) {
      return this.usuarioLogado.infoRFB;
    }

    return null;
  }
}
